import React from "react";

import { Tooltip } from "@material-ui/core";

import {
  AutoIcon,
  CustomCodeIcon,
  ManualIcon,
} from "../../../../components/common/iconography";

import { BillingAutomation } from "./chargeRuleConstants";

export const ExecutionIcon = ({ record, ...props }) => {
  if (!record) return null;
  if (record.execution === BillingAutomation.AUTO)
    return (
      <Tooltip title="Auto" placement="right" arrow>
        <AutoIcon />
      </Tooltip>
    );
  if (record.execution === BillingAutomation.CUSTOM)
    return (
      <Tooltip title="Custom Code" placement="right" arrow>
        <CustomCodeIcon />
      </Tooltip>
    );
  // Default / MANUAL or undefined
  return (
    <Tooltip title="Manual" placement="right" arrow>
      <ManualIcon />
    </Tooltip>
  );
};
